/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertRuleDto } from '../../models/alert-rule-dto';
import { CreateAlertRuleRequest } from '../../models/create-alert-rule-request';

export interface AlertsPost$Json$Params {
      body?: CreateAlertRuleRequest
}

export function alertsPost$Json(http: HttpClient, rootUrl: string, params?: AlertsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertRuleDto>> {
  const rb = new RequestBuilder(rootUrl, alertsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertRuleDto>;
    })
  );
}

alertsPost$Json.PATH = '/alerts';
